/* eslint semi:0 */
import m from 'mithril'
import BaseVm from './BaseVm'
import GoogleSearchStore from '../stores/googleSearchStore'
import { searchClicked } from '../actions/googleSearchActions'

class GoogleSearchVm extends BaseVm {
  constructor(options = {}) {
    options.store = options.store || GoogleSearchStore.create()
    super(options)
    this.searchboxValue = m.prop('')
  }

  search(e) {
    e.preventDefault()
    searchClicked(this.searchboxValue())
  }
}

export default GoogleSearchVm



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/vms/googleSearchVm.js